<template>
  <v-row density="compact">
    <p>
      Keltner Channels are drawn a number of ATRs above and below a moving average. A close above
      the upper channel signals a bullish breakout; a close below the lower channel a bearish one.
      The "squeeze" option instead matches low-volatility stocks whose Bollinger Bands have
      contracted inside the Keltner Channel — often a precursor to a large move.
    </p>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.above_below"
        :items="above_below"
        item-title="title"
        item-value="value"
        label="Signal"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.ma_days"
        :items="ma_days"
        label="Moving Average Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('ma_days', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.atr_mult"
        density="compact"
        hide-details
        variant="outlined"
        label="ATR Multiplier (channel width, e.g. 2)"
        @update:model-value="updateConfig('atr_mult', $event)"
      />
    </v-col>
    <v-col v-if="rule.config.above_below == 'squeeze'" cols="12">
      <p class="text-caption text-medium-emphasis">
        Squeeze mode uses the standard-deviation column for the chosen MA period, which is only
        available for periods of 30 days or fewer.
      </p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      ma_days: [5, 10, 20],
      above_below: [
        { title: 'Close above upper channel (breakout up)', value: 'above' },
        { title: 'Close below lower channel (breakdown)', value: 'below' },
        { title: 'Volatility squeeze (Bollinger inside Keltner)', value: 'squeeze' }
      ],
      defaultTa: {
        enabled: true,
        rule_type: 'keltner',
        ma_days: 20,
        atr_mult: 2,
        above_below: 'above',
        long_short: 'long'
      }
    }
  },

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'keltner') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
